const DIRECTIONS = ["added", "removed", "changed"];
const joinWithAnd = (phrases) => {
    if (phrases.length <= 1)
        return phrases.join("");
    return `${phrases.slice(0, -1).join(", ")} and ${phrases[phrases.length - 1]}`;
};
const countLabel = (count, category) => `${count.toLocaleString()} ${count === 1 ? category.singular : category.plural}`;
/**
 * Composes count-based change categories into the summary sentence, grouping
 * every category by the direction of its change:
 * "5 indicators and 2 vulnerabilities added, 3 tags removed, 4 network
 * references changed." A category with changes in more than one direction
 * appears in each matching clause. Returns "" when nothing changed.
 */
export const composeChangeNarrative = (categories) => {
    const clauses = DIRECTIONS.map((direction) => {
        const phrases = categories
            .filter((category) => category[direction] > 0)
            .map((category) => countLabel(category[direction], category));
        return phrases.length > 0 ? `${joinWithAnd(phrases)} ${direction}` : null;
    }).filter((clause) => clause !== null);
    if (clauses.length === 0)
        return "";
    return `${clauses.join(", ")}.`;
};
//# sourceMappingURL=changeNarrative.js.map